import { COOKIES_POLICY_URL } from '@constants';
import { useScreenSize } from '@hooks';
import { Flex, Link, theme } from '@styles';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as cookie } from '../../assets/svgs/cookieIcon.svg';
import { Icon } from '../Icon';
import {
  getDataFromLS,
  setDataToLS,
  StyledButton,
  StyledTypography,
} from './CookiesModal.propTypes';

const CookiesModal = () => {
  const [isShown, setIsShown] = useState(false);
  const [isDisplayed, setIsDisplayed] = useState(false);
  const { isTabletLG } = useScreenSize();
  const { i18n } = useTranslation();

  const onAcceptClick = () => {
    setDataToLS('cookiesAccepted', true);
    // TO DO!!!! doesnt work
    // amplitude.getInstance().enableTracking()
    setIsShown(false);
    setTimeout(() => {
      setIsDisplayed(false);
    }, 1000);
  };

  useEffect(() => {
    const isToBeShown = !getDataFromLS('cookiesAccepted');
    if (isToBeShown) {
      setIsDisplayed(true);
      setTimeout(() => {
        setIsShown(true);
      }, 1000);
    }
  }, []);

  return (
    <Flex
      backgroundColor={theme.colors.schoolBusYellow[100]}
      bottom="0"
      display={isDisplayed ? 'flex' : 'none'}
      opacity={isShown ? 1 : 0}
      position="fixed"
      style={{
        transition: 'opacity 1s ease-out',
      }}
      width="100%"
      zIndex={100}
    >
      <Flex
        alignItems="center"
        backgroundColor="rgb(255,255,255,0.5)"
        paddingLeft={isTabletLG ? '20px' : '57px'}
        paddingRight={isTabletLG ? '20px' : '57px'}
      >
        <Icon alt="cookie" height={68} SVG={cookie} width={68} />
      </Flex>
      <Flex
        justifyContent="space-between"
        {...(isTabletLG && { flexDirection: 'column' })}
        padding="26px"
        width="100%"
      >
        <Flex flexDirection="column" {...(!isTabletLG && { width: '50%' })}>
          <StyledTypography marginBottom="6px" title>
            {i18n.t('cookies.title')}
          </StyledTypography>
          <Link target="_blank" to={COOKIES_POLICY_URL}>
            <StyledTypography color={theme.colors.black[100]}>
              {i18n.t('cookies.description')}
            </StyledTypography>
          </Link>
        </Flex>
        <Flex
          alignSelf="center"
          display="inline-block"
          {...(isTabletLG && { marginTop: '10px', width: '100%' })}
        >
          <StyledButton
            alignSelf="center"
            backgroundColor={theme.colors.black}
            color={theme.colors.white[100]}
            onClick={onAcceptClick}
            {...(isTabletLG && { width: '100%' })}
          >
            {i18n.t('cookies.button')}
          </StyledButton>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default CookiesModal;
